import { StatementBalanceModel } from "@app/core/models/transaction/balance-statement.model";
import { createAction, props } from "@ngrx/store";


export const getStatementofBalance = createAction('[Transaction] Get Statement of Balance', props<{accountId: string, fromDate: string, toDate: string}>());
export const getStatementofBalanceSuccess = createAction('[Transaction] Get Statement of Balance Success', props<{data: StatementBalanceModel}>());